import React from 'react';
import GenieConfiguration from './profile/GenieConfiguration';
import { useRouteMatch } from 'react-router-dom';
import NavBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';

export default function MyGenie() {
    const { path, url } = useRouteMatch();

    return (
        <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
            <NavBar />
            <div className="flex flex-col h-full col-span-11 overflow-hidden">
                <NewHeaderComponent title="My Genie" />
                <GenieConfiguration path={path} url={url} />
            </div>
        </div>
    );
}
